export { TableMobile } from "./TableMobile";
export { CellDetailsMobile } from "./components";
